import React from "react";

const cls = (score) => {
  if (score >= 85) return "bg-emerald-500/15 text-emerald-400 border-emerald-500/25";
  if (score >= 70) return "bg-teal-500/15 text-teal-300 border-teal-500/25";
  if (score >= 55) return "bg-blue-500/15 text-blue-300 border-blue-500/25";
  if (score >= 40) return "bg-amber-500/15 text-amber-300 border-amber-500/25";
  return "bg-zinc-500/15 text-zinc-400 border-zinc-500/25";
};

export default function ScoreBadge({ score, size = "sm", testid, tip }) {
  const defaultTip = "Overall signal score (0–100) — weighted composite of trader quality, consensus, conviction, remaining edge, liquidity, timing and data completeness.";
  if (score == null) {
    return (
      <span
        data-testid={testid}
        title={tip || defaultTip}
        className="inline-flex items-center rounded-sm border border-zinc-700 bg-zinc-800/40 text-zinc-500 px-1.5 py-0.5 text-[10px] font-mono-num uppercase tracking-wider"
      >
        —
      </span>
    );
  }
  const s = Math.round(score);
  return (
    <span
      data-testid={testid}
      title={tip || defaultTip}
      className={`inline-flex items-center gap-1 rounded-sm border ${cls(s)} ${
        size === "lg" ? "px-2 py-0.5 text-sm" : "px-1.5 py-0.5 text-xs"
      } font-mono-num`}
    >
      {s}
    </span>
  );
}
